import _ from "underscore"
import f from './functions.js'

var address = 'https://' + process.env.VUE_APP_SERVER
class Promocode {
    fields = [
        'code',
        'end',
        'feature',
        'id',
        'owner',
        'planid',
        'start'
    ]

    constructor(data = {}) {

        _.each(data, (v, i) => {
            this[i] = v
        })


        var pfeature = JSON.parse(this.feature)

        this.discount = pfeature.discount || 0
        this.reward = pfeature.reward || 0


        this.start = new Date(this.start)
        this.end = new Date(this.end)
    }

    clone = function(){
        var data = {}

        _.each(this.fields, (i) => {
            data[i] = _.clone(this[i])
        })

        return new Promocode(data)
    }

    active = function(){
        var now = new Date()

        return this.start < now && this.end > now
    }

    status = function(){
        if(this.active()) return 'active'

        var now = new Date()

        if(now < this.start) return 'notstarted'
        if(now > this.end) return 'end'

    }
}


class Task {
    fields = [
        'status',
        'date',
        'workflow',
        'purpose',
        'uid'
    ]

    constructor(data = {}) {

        _.each(data, (v, i) => {
            this[i] = v
        })


        this.date = new Date(this.date)

        this._purpose = JSON.parse(this.purpose)
        this._workflow = JSON.parse(this.workflow)
    }

    clone = function(){
        var data = {}

        _.each(this.fields, (i) => {
            data[i] = _.clone(this[i])
        })

        return new Promocode(data)
    }
}

class Podcast {
    constructor(data = {}) {

        if(this.prepared) return

        _.each(data, (v, i) => {
            this[i] = v
        })

        if (this.cover && this.cover.indexOf(address) == -1) this.cover = address + '/' + this.cover

        this.title = this.name
        this.scenes = []

        if (this.audio){
            this.audio = {
                ...this.audio,
                path : address + '/' + this.audio.path
            }
        }

        if (this.intro && this.intro.duration){
            this.intro = {
                ...this.intro,
                path : address + '/' + this.intro.path
            }

            this.intro.duration = this.intro.duration + 2

            if (this.audio){
                this.audio.start = this.intro.duration

                if (this.audio.segments){
                    _.each(this.audio.segments, (s) => {
                        s.startTimeSeconds = s.startTimeSeconds + this.intro.duration
                        s.endTimeSeconds = s.endTimeSeconds + this.intro.duration
                    })
                }
            }

            this.scenes.unshift({
                duration : this.intro.duration,
                intro : true
            })

            this.duration = this.duration + this.intro.duration

        }

        if (this.backgroundaudio){
            this.backgroundaudio = {
                ...this.backgroundaudio,
                path : address + '/' + this.backgroundaudio.path
            }
        }

        var mainscene = {
            duration : this.audio.duration,
            podcast : true,
            characters : []
        }

        _.each(this.characters, (character) => {
            mainscene.characters.push({
                ...character,   
                image : address + '/' + this.characterImages[character.name]
            })
        })

        this.scenes.push(mainscene)

        if(!this.outAdded){
            this.outAdded = true

            this.scenes.push({
                duration : 4,
                out : true
            })

            this.duration = this.duration + 4
        }

        var dur = 0

        this.scenes = _.map(this.scenes, (scene) => {
            var nc = {...scene}

            if (nc.image && nc.image.indexOf(address) == -1) nc.image = address + '/' + nc.image

            nc.start = dur
            nc.end = dur + scene.duration
            dur = dur + scene.duration

            return nc
        })

        this.content = ''

        _.each(this.parts, (part) => {
            _.each(part.editedDialog, (d) => {
                this.content = this.content + "\n" + d.character + ": " + d.text
            })
        })

        this.podcast = true

        this.prepared = true

    }
}

class Story {
    

    constructor(data = {}, address) {

        _.each(data, (v, i) => {
            this[i] = v
        })

        this.scenes = [...this.scenes]

        if (this.cover) this.cover = address + '/' + this.cover

        if (!this.circle && this.intro && this.intro.duration && !this.introAdded){
            this.intro = {
                ...this.intro,
                path : address + '/' + this.intro.path
            }

            this.intro.duration = this.intro.duration + 2

            if (this.audio){
                this.audio.start = this.intro.duration
            }

            if (this.backgroundaudio){
                this.backgroundaudio.start = this.intro.duration - 2
            }


            this.scenes.unshift({
                duration : this.intro.duration,
                intro : true
            })

            this.duration = this.duration + this.intro.duration

            this.introAdded = true

        }

        if(!this.circle && !this.outAdded){
            this.outAdded = true

            this.scenes.push({
                duration : 4,
                out : true
            })

            this.duration = this.duration + 4
        }

        var dur = 0

        var totalsceneduration = _.reduce(this.scenes, (m, scene) => {
            return scene.duration || 0
        }, 0)

        var scenesWithoutDuration = _.filter(this.scenes, (scene) => {
            return !scene.duration
        })

        this.scenes = _.map(this.scenes, (scene) => {
            var nc = {...scene}

            if (nc.image) nc.image = address + '/' + nc.image

            if(!scene.duration && this.duration){
                scene.duration = (this.duration - totalsceneduration) / scenesWithoutDuration.length
            }

            nc.start = dur
            nc.end = dur + scene.duration
            dur = dur + scene.duration

            return nc
        })

        this.footnotes = _.map(this.footnotes, (footnote) => {
            var nc = {...footnote}

            if (nc.image) nc.image = address + '/' + nc.image
            if (nc.audio) nc.audio = {
                ...nc.audio,
                path : address + '/' + nc.audio.path
            }

            return nc
        })

        if (this.audio){
            this.audio = {
                ...this.audio,
                path : address + '/' + this.audio.path
            }
        }

        if (this.backgroundaudio){
            this.backgroundaudio = {
                ...this.backgroundaudio,
                path : address + '/' + this.backgroundaudio.path
            }
        }

        this.textduration = dur

        if (!this.circle && this.questions){
            this.questions = _.map(this.questions, (question) => {
                var nc = {...question}

                if (nc.image) nc.image = address + '/' + nc.image
                if (nc.audio) nc.audio = {
                    ...nc.audio,
                    path : address + '/' + nc.audio.path
                }
                if (nc.audioAnswers) nc.audioAnswers = {
                    ...nc.audioAnswers,
                    path : address + '/' + nc.audioAnswers.path
                }

                return nc
            })

            if(!this.questionsAddedToScenes){

                var addedScenes = []

                _.each(this.questions, (question, index) => {

                    if(!_.indexOf(question.answers, question.answer) == -1) return

                    var startOffset = 0.3

                    var scene = {
                        audios : [{
                            ...question.audio,
                            start : startOffset
                        },{
                            ...question.audioAnswers,
                            start : startOffset + question.audio.duration + startOffset
                        }],
                        question : {
                            ...question,
                        }
                    }

                    scene.duration = Math.max(startOffset + question.audio.duration + startOffset + question.audioAnswers.duration + 2, 5)

                    addedScenes.push(scene)
                    
                })

                if(addedScenes.length){

                    this.scenes.push({
                        start : dur,
                        end : dur + 3,
                        duration : 3,
                        system : {
                            text : 'snippity.questions',
                            sticker : 'questions.png',
                        }
                    })

                    dur = dur + 3

                    _.each(addedScenes, (scene, i) => {

                        scene.start = dur
                        scene.end = dur + scene.duration
                        dur = dur + scene.duration

                        scene.question.index = i
                        scene.question.count = addedScenes.length
                        
                        this.scenes.push(scene)
                    })


                    this.scenes.push({
                        start : dur,
                        end : dur + 3,
                        duration : 3,
                        system : {
                            text : 'snippity.questionsend',
                            sticker : 'questionsend.png'
                        }
                    })

                    dur = dur + 3

                }

                this.duration = dur

                this.questionsAddedToScenes = true
            }
            
            
        }
       
    }

}

class Lesson {
    

    constructor(data = {}) {

        _.each(data, (v, i) => {
            this[i] = v
        })

        if (this.cover && this.cover.indexOf(address) == -1) this.cover = address + '/' + this.cover

        _.each(this.lessons, (l, index) => {
            if (l.cover && l.cover.indexOf(address) == -1) l.cover = address + '/' + l.cover

            l.uid = 'lesson' + index
        })

    }

}

class LessonProgress {

    constructor(data = {}) {

        _.each(data, (v, i) => {
            this[i] = v
        })

        if (this.progress) {

            try{
                this.progress = JSON.parse(this.progress)
            }catch(e){

            }

            this.progress = _.sortBy(this.progress, (p) => {
                return p.index
            })

            _.each(this.progress, (p) => {
                p.date = new Date(p.date)
            })
        }
    }

    join = function() {
        return this.id ? true : false
    }

    beginned = function(){
        return this.progress && this.progress.length
    }

    finished = function(course) {

        if(!course) return false

        return this.join() && course.lessons.length <= this.progress?.length
    }

    check = function(index){
        return _.find(this.progress, (p) => {
                return p.index == index
        }) ? true : false
    }

    next = function(course) {

        if(!course) return null

        if(!this.join() || !this.progress || !this.progress.length) return course.lessons[0]
        
        if(this.finished()) return null

        return _.find(course.lessons, (l, index) => {
            return !_.find(this.progress, (p) => {
                return p.index == index
            })
        })
    }

    status(){
        if(this.finished()) return 'finished'
        if(this.join()) return 'join'

        return 'none'
    }

    lessonStatuses(course, prefix = ''){
        
        var statuses = {}
        var hasnext = false

        _.each(course.lessons, (l, index) => {
            if(_.find(this.progress, (p) => {
                return p.index == index
            })){
                statuses[prefix + index] = {
                    value : 'finished'
                }

                return
            }

            statuses[prefix + index] = {
                value : 'wait'
            }

            if(!hasnext){
                if(!_.find(this.progress, (p) => {
                    return p.index == index
                })){
                    hasnext = true

                    statuses[prefix + index] = {
                        value : 'current'
                    }

                    if(index > 0) {
                        var lp = _.find(this.progress, (p) => {
                            return p.index == index - 1
                        })

                        if (lp){

                            var until = f.date.addDays(lp.date, 1)

                            if (until > new Date){
                                statuses[prefix + index].waituntil = until
                            }

                            
                        }
                    }
                }
            }
        })


        return statuses

    }


}

export {
    Promocode, Task, Story, Lesson, LessonProgress, Podcast
}